import { useTablePagination } from '@/common/hooks/useTablePaginate'
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectLabel,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'

interface DataTableSelectorProps {
	options: {
		label: string
		value: string
	}[]
	placeholder?: string
	label?: string
}

export function DataTableSelector({
	options,
	placeholder,
	label,
}: DataTableSelectorProps) {
	const { setSelectedQuery } = useTablePagination()

	const allOptions = [{ label: 'ทั้งหมด', value: '' }, ...options]

	const handleSelectedChange = (value: string) => {
		setSelectedQuery(value)
	}

	return (
		<div className="flex space-x-2">
			<Select onValueChange={handleSelectedChange}>
				<SelectTrigger className="w-[180px]">
					<SelectValue placeholder={placeholder} />
				</SelectTrigger>
				<SelectContent>
					<SelectGroup>
						{label && <SelectLabel>{label}</SelectLabel>}
						{allOptions.map((option) => (
							<SelectItem key={option.value} value={option.value}>
								{option.label}
							</SelectItem>
						))}
					</SelectGroup>
				</SelectContent>
			</Select>
		</div>
	)
}
